"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobsService = void 0;
class JobsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Create new import job ASYNC
     * @param requestBody
     * @returns NewImportJobResponse
     * @throws ApiError
     */
    createNewImportJob(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/jobs/import',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get job information by id
     * @param id job uuid
     * @returns GetJobResponse
     * @throws ApiError
     */
    getJob(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/jobs/{id}',
            path: {
                'id': id,
            },
        });
    }
}
exports.JobsService = JobsService;
